export const PAGINATION_PER_PAGE_COUNTS = [10, 20, 50];
